import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetCustomReportConfigsRequestSchema,
  TGetCustomReportConfigsResponseSchema,
} from "./getCustomReportConfigs.schema";

export const getCustomReportConfigs = (axios: IAxiosInstance) => {
  return async (data: TGetCustomReportConfigsRequestSchema) => {
    const { template } = data;

    const response = await axios.noRetry.get<
      IApiResponse<TGetCustomReportConfigsResponseSchema>
    >(`/api/customReports/configs`, { params: { template } });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
